<template>
    <div class="payCheckPage">
        <!-- 顶部用户信息 -->
        <div class="userInfoBox">
            <div class="userInfoLeft">
                <img class="userAvatar" src="../assets/icon8.png" alt="avatar">
                <div class="userTextBox">
                    <div class="userTextLine">
                        <img style="width:20px;" src="../assets/icon9.png" v-if="userInfo.memberType != 0" alt="">
                        <span class="userId">{{userInfo.userName}}</span>
                    </div>
                    <span class="logoutBtn">
                    <span class="welcomeText">您好，欢迎登录</span>
                    <span class="welcomeText" @click="exit()">退出</span>
                    </span>
                </div>
            </div>
            <div v-if="userInfo.memberType != 0" style="flex-grow: 1;display: flex;">
                <div class="memberTypeBox">
                    <span class="memberText">
                        <img style="width:16px;margin-right:6px" :src="require(`../assets/${userInfo.memberTypeIcon}`)" alt="">
                        {{userInfo.memberTypeName}}
                    </span>
                    <span class="expireTime">会员有效期至：{{userInfo.memberExpire}}</span>
                </div>
                <div class="btnGroup">
                    <!-- <button class="upgradeBtn" v-if="userInfo.memberType != 100" @click="updateMember()">升级为全平台会员</button> -->
                    <button class="renewBtn" @click="renewMember()">会员续费</button>
                </div>
            </div>
            <div v-else style="display:flex;align-items: center;">
                <div style="margin-right:30px;color:#F9D9A8;font-size: 14px;font-weight: 400;">无会员</div>
                <div class="btnGroup">
                    <button class="upgradeBtn" @click="newMember()">升级为会员</button>
                </div>
            </div>
        </div>
    
        <div class="wrap">
            <!-- 支付记录列表 -->
            <div class="payListBox">
                <div class="payListItem" v-for="(item, index) in paymentList" :key="index">
                    <div class="orderInfoBox">
                        <div class="orderId">{{item.orderNo}}</div>
                        <div class="orderTime">{{item.subject}}</div>
                    </div>
                    <div class="paymentInfoBox">
                        <div class="paymentType">{{item.payBackTime}}</div>
                        <div class="paymentFee">
                            <div class="paymentAmount">¥ {{item.amount}}</div>
                            <div class="paymentMethod">{{item.payTypeStr}}</div>
                        </div>
                    </div>
                </div>
            </div>
    
            <!-- 分页器 -->
            <div class="paginationBox">
                <el-pagination background layout="prev, pager, next" :total="totalCount" :page-size="20" :current-page="currentPage" @current-change="handlePageChange">
                </el-pagination>
            </div>
        </div>
    </div>
</template>
  
<script>
import { getUserInfo, appCoverToWeb } from '@/api/user'
import { getOrderList } from '@/api/pay'
import Cookies from 'js-cookie'
export default {
    name: 'PayCheck',
    data() {
        return {
            //用户信息
            userInfo: {
                userName: "xxxxxx",
                memberExpire: "",
                memberType: 0,
                memberTypeName: "",
                memberTypeIcon: "",
            },

            //分页
            currentPage: 1,
            totalCount: 0,

            //列表数据
            paymentList: [],
        }
    },

    mounted() {
        this.initPage();
    },

    methods: {
        //初始化页面
        initPage() {
            let frommethodVal = 0;
            const frommethod = this.$route.query.frommethod; // 例如获取名为paramName的参数
            try {
                if (!(frommethod === undefined)) {
                    frommethodVal = parseInt(frommethod);
                }
            } catch (err) {
                //
            }

            //判断是WEB的页面，还是APP的页面
            if (frommethodVal == 0) {
                this.loadUserInfo();
                this.loadOrderList();
            } else {
                console.log("1111111")
                //读取浏览器参数
                let tokenVal = "";
                try {
                    const tokenStr = this.$route.query.key; // 例如获取名为paramName的参数
                    if (!(tokenStr === undefined)) {
                        tokenVal = tokenStr;
                    }
                } catch (err) {
                    //
                }
                if (tokenVal == "") {
                    this.$message.error('登录失败，请重新点击应用程序登录')
                    return;
                }
                //用户先登录
                this.loginUserByApp(frommethodVal, tokenVal);
            }
        },
        handlePageChange(page) {
            //console.log(page);
            if (this.currentPage != page) {
                this.currentPage = page;
                this.loadOrderList();
            }
        },

        //退出登录
        exit() {
            this.$confirm('确定要退出吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            }).then(() => {
                Cookies.remove('ss_user_token')
                this.$router.push('/login');
            }).catch(() => {
                //
            });
        },

        //升级会员
        updateMember() {
            this.$router.push('/pay?type=2');
        },

        //续费
        renewMember() {
            this.$router.push('/pay?type=1');
        },

        //开通会员
        newMember() {
            this.$router.push('/pay?type=0');
        },

        //设置icon
        loadParamsIcon() {
            if (this.userInfo.memberType == 1) {
                this.userInfo.memberTypeIcon = "icon11.png";
                this.userInfo.memberTypeName = "Windows会员";
            } else if (this.userInfo.memberType == 100) {
                this.userInfo.memberTypeIcon = "icon13.png";
                this.userInfo.memberTypeName = "全功能会员";
            }
        },

        //用户登录
        async loginUserByApp(fromMethodVal, tokenVal) {
            const params = {
                fromDevice: fromMethodVal,
                data: tokenVal
            }
            try {
                const res = await appCoverToWeb(params);
                //设置cookie
                if (res.success) {
                    //重新载入数据
                    this.$router.replace('/user');
                    //this.loadUserInfo();
                    //this.loadOrderList();
                    this.initPage();
                } else {
                    this.$message.error(res.msg)
                }
            } catch (err) {
                this.$message.error('登录失败，请重新点击应用程序登录')
            }
        },

        //载入用户信息
        async loadUserInfo() {
            try {
                const res = await getUserInfo();
                //console.log(res)
                if (res.success) {
                    this.userInfo = res.data;
                    //this.userInfo.memberType = 100;
                    //this.userInfo.memberType = 0;
                    this.loadParamsIcon();
                } else {
                    this.$message.error(res.msg)
                }
            } catch (err) {
                let msgFlag = true;
                try {
                    if (err.status === 401) {
                        msgFlag = false;
                        this.$router.push('/login');
                        this.$message.error('用户未登录，请先登录');
                    }
                } catch (err2) {
                    //
                }
                if (msgFlag) {
                    this.$message.error('请求失败');
                }
            }
        },

        //载入支付记录
        async loadOrderList() {
            const params = {
                pageNum: this.currentPage, 
                pageSize: 20
            }
            try {
                const res = await getOrderList(params);
                //console.log(res)
                if (res.success) {
                    this.paymentList = res.data;
                    this.totalCount = res.total;
                } else {
                    this.$message.error(res.msg)
                }
            } catch (err) {
                let msgFlag = true;
                try {
                    if (err.status === 401) {
                        msgFlag = false;
                    }
                } catch (err2) {
                    //
                }
                if (msgFlag) {
                    this.$message.error('请求失败')
                }
            }
        },
    }
}
</script>
  
<style scoped lang="less">
.payCheckPage {
    min-height: 100vh;
    color: #fff;
    background-color: #fefefe;
    .userInfoBox {
        display: flex;
        align-items: center;
        padding: 24px;
        background: linear-gradient(to bottom, #45443D, #1A150F);
        .userInfoLeft {
            display: flex;
            align-items: flex-start;
            flex-grow: 1;
            .userAvatar {
                width: 44px;
                height: 44px;
                border-radius: 50%;
                margin-right: 12px;
            }
            .userTextBox {
                display: flex;
                flex-direction: column;
                gap: 4px;
                .userTextLine {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    .userId {
                        font-size: 16px;
                        color: #F9D9A8;
                        line-height: 22px;
                        font-weight: 600;
                    }
                }
                .logoutBtn {
                    color: #808080;
                    cursor: pointer;
                    .welcomeText {
                        font-size: 12px;
                        line-height: 22px;
                        margin-right: 20px;
                    }
                }
            }
        }
        .memberTypeBox {
            display: flex;
            align-items: center;
            gap: 20px;
            flex-grow: 1;
            .windowsIcon {
                width: 20px;
                height: 20px;
            }
            .memberText {
                font-size: 14px;
                color: #F9D9A8;
                line-height: 22px;
                font-weight: 600;
                display: flex;
                align-items: center;
            }
        }
        .expireTime {
            font-size: 12px;
            color: #F9D9A8;
            line-height: 22px;
            font-weight: 400;
        }
        .btnGroup {
            display: flex;
            gap: 12px;
            .upgradeBtn,
            .renewBtn {
                height: 32px;
                padding: 0 16px;
                border-radius: 4px;
                font-size: 14px;
                cursor: pointer;
                white-space: nowrap;
            }
            .upgradeBtn {
                background: #FFF4E7;
                color: #815A12;
                border: none;
            }
            .renewBtn {
                background: #FFF4E7;
                color: #815A12;
                border: none;
            }
        }
    }
    .wrap {
        padding: 20px 200px;
        .payListBox {
            .payListItem {
                background: #fff;
                border-radius: 6px;
                padding: 20px 24px;
                margin-bottom: 12px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                border: 1px solid #EBEBEB;
                .orderInfoBox {
                    .orderId {
                        font-size: 12px;
                        margin-bottom: 4px;
                        color: #333;
                        line-height: 24px;
                        font-weight: 400;
                    }
                    .orderTime {
                        color: #333;
                        font-size: 12px;
                        line-height: 22px;
                        font-weight: 600;
                    }
                }
                .paymentInfoBox {
                    text-align: right;
                    .paymentType {
                        color: #D4D4D4;
                        font-size: 12px;
                        line-height: 22px;
                        font-weight: 400;
                    }
                    .paymentFee{
                        display: flex;
                        align-items: center;
                        .paymentAmount {
                            font-size: 16px;
                            color: #333;
                            line-height: 24px;
                            min-width: 60px;
                            text-align: right;
                            font-weight: 600;
                        }
                        .paymentMethod {
                            color: #333;
                            font-size: 12px;
                            line-height: 22px;
                            min-width: 70px;
                            font-weight: 400;
                        }
                    }

                }
            }
        }
        .paginationBox {
            display: flex;
            justify-content: center;
            margin-top: 40px;
            :deep(.el-pagination) {
                .btn-prev,
                .btn-next,
                .el-pager li {
                    background-color: transparent;
                    color: #2F3133;
                    border: 1px solid #CED4DB;
                    margin: 0 4px;
                    &:hover {
                        color: #333;
                        border-color: #CED4DB;
                    }
                    &.active {
                        background-color: #EE71A7;
                        color: #fff;
                        border-color: #EE71A7;
                    }
                    &.disabled {
                        color: #4D4D4D;
                        border-color: #2F3133;
                    }
                }
            }
        }
    }
}
</style>